import React from 'react';
import styles from './TabsContent.module.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

export const ArzatorAltepDescription = () => {
  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Caracteristici</h1>
      <p className={styles.text}>
        Arzătoarele cu peleți Altep sunt un dispozitiv tehnologic modern pentru arderea biomasei. Arzătoarele sunt echipate cu un mecanism care curăță arzătorul de zgură și cenușă formate in urma arderii combustibilului.
      </p>
      <p className={styles.text}>
        Aprinderea arzătorului, arderea combustibilului, stingerea și curățarea arzătorului se efectuează automat, adică arzătorul nu are nevoie de întreținere. Aprinderea constă în încărcarea inițială și aprinderea flăcării prin încălzirea combustibilului la temperatura de aprindere, folosind o brichetă instalată în arzător. Arderea și stingerea arzătorului sunt controlate de dispozitivul de control (vezi manualul dispozitivul de control).
      </p>
      <p className={styles.text}>
        Curățarea constă în aruncarea reziduurilor de combustie. Curățarea se efectuează ciclic și contribuie la arderea completă a combustibilului, ceea ce asigură funcționarea economică și respectarea mediului.Curățarea prelungește durata de viață a arzătorului. Arzătoarele de acest tip sunt compatibile cu cazanele de încălzire cu combustibil solid, precum și cu unele cazane pe gaz și pe ulei echipate cu o cameră de ardere și cutie de cenușă.
      </p>
      <p className={styles.text}>
        Arzătorul Altep este un dispozitiv ecologic conceput pentru a arde combustibili din surse regenerabile, cum ar fi pelete sau agro-pelete. Arzătorul este controlat de dispozitivul de control inclus in pachetul de livrare a dispozitivului de control. Reglarea lină a raportului combustibil-oxigen vă permite să reglați puterea dispozitivului în funcție de necesități. La dispozitivul de control pot fi conectate până la 4 pompe și 3 supape de amestecare. Poate deservi până la 6 senzori de temperatură (inclusiv senzori pentru sistemul de încălzire, apă caldă menajeră, supapă, debit de retur, senzori tampon rezervor). Numeroase soluții pentru confort sporit, inclusiv senzorul de gaze arse PID, regulatorul de cameră, sonda lambda, fac întreținerea și funcționarea arzătorului cât mai simple și convenabile posibil.
      </p>
      <p className={styles.text}>
        Arzătorul este echipat cu numeroase dispozitive de protecție împotriva incendiilor care opresc alimentarea cu combustibil în caz de accident sau supraîncălzire, iar acest lucru, la rândul său, ajută la prevenirea răspândirii focului și a producerii unui incendiu. Penile de curent nu vor afecta negativ dispozitivul, deoarece doar o cantitate mică de combustibil este alimentată în camera de ardere.
      </p>
      <p className={styles.text}>
        Combustibilul care intră în arzător trebuie depozitat într-un recipient închis ermetic și trebuie transportat folosind un alimentator spiralat Altep cu lungime și capacitate corespunzătoare.
      </p>
    </div>
  );
};

export const ArzatorAltepInstructions = () => {

  return (
    <div className={styles.container}>
      <a
        href="/pdfs/arzator-altep.pdf"
        download="Manual_de_utilziare_Arzator_Altep.pdf"
        className={styles.pdfLink}
      >
        <i className={`fa-solid fa-file-pdf ${styles.pdfIcon}`} />
        <h1 className={styles.title}>Manual de utilizare</h1>
      </a>
    </div>
  );
};


